import { NewsletterTemplate } from "../../types";
import { TemplateCard } from "./TemplateCard";

interface TemplateGridProps {
  templates: NewsletterTemplate[];
  onEdit: (template: NewsletterTemplate) => void;
  onView: (template: NewsletterTemplate) => void;
  onSelect: (id: string) => void;
  onDelete: (template: NewsletterTemplate) => void;
}

export const TemplateGrid = ({ 
  templates,
  onEdit,
  onView,
  onSelect,
  onDelete
}: TemplateGridProps) => {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          onEdit={onEdit}
          onView={onView}
          onSelect={onSelect}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};